<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-container grid-list-xl fluid>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="productList"
                    :pagination.sync="pagination"
                    select-all
                    item-key="description "
                    class="elevation-1"
                >
                    <template v-slot:items="props">
                        <tr v-if="props.item.quantityApproved>0 ">
                            <td>
                                <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                            </td>
                            <td class="text-xs-left">{{ props.item.description }}</td>
                            <td class="text-xs-left">{{ props.item.stamp }}</td>
                            <td class="text-xs-left">{{ props.item.unity}}</td>
                            <td class="text-xs-left">{{ props.item.quantityApproved }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
import ProductService from '../../../service/ProductService.js'
export default {
    props: {
        productList: {
            type: Array,
        },
        typeProduct: String,
    },
    data: () => ({
        pagination: {
            sortBy: 'description',
        },
        selected: [true],
        headers: [
            {text: 'Descrição',align: 'left',value: 'description',},
            { text: 'Marca', value: 'stamp' },
            { text: 'Unidade de Medida', value: 'unity' },
            { text: 'Quantidade', value: 'quantityApproved' },
        ],
        products: [],
    }),
    async beforeMount() {
        await this.loadProducts();
        this.selected = [true]
    },
    methods: {
        async loadProducts() {
            this.products = await ProductService.getByCategory({
                type: 'Material de Consumo',
            })
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/contract/Request/ListItems.vue